import { render, staticRenderFns } from "./SendDetailsModal.vue?vue&type=template&id=0f3087cc&scoped=true&"
import script from "./SendDetailsModal.vue?vue&type=script&lang=js&"
export * from "./SendDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./SendDetailsModal.vue?vue&type=style&index=0&id=0f3087cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3087cc",
  null
  
)

export default component.exports